'use client'

import dynamic from 'next/dynamic'

// `ssr: false` with next/dynamic is only allowed in Client Components.
// This wrapper exists solely to be that boundary — layout.tsx (a Server
// Component) imports this file instead of the widget directly.
const SeeWhatAiSaysWidgetDynamic = dynamic(
  () =>
    import('@/components/marketing/see-what-ai-says-widget').then((m) => ({
      default: m.SeeWhatAiSaysWidget,
    })),
  { ssr: false },
)

export function SeeWhatAiSaysWidgetClient({ className }: { className?: string }) {
  return <SeeWhatAiSaysWidgetDynamic className={className} />
}
